"use client";

import styled from "styled-components";

export const OpeningBlock = styled.div`
  position: relative;
  isolation: isolate;
  .btn-accent {
    background: #c8ff26;
    img {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
    .action {
      color: #000;
    }
    @media (max-width: 1023px) {
      width: 100%;
    }
  }
`;

export const TagsUnit = styled.div`
  border-radius: var(--rounding-radius-m, 16px);
  background: rgba(204, 187, 184, 0.16);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  padding: var(--spacing-space-4, 4px) var(--spacing-space-12, 12px)
    var(--spacing-space-4, 4px) var(--spacing-space-4, 4px);
  align-items: center;
  gap: var(--spacing-space-4, 4px);
  display: flex;
  gap: 4px;
  color: rgba(242, 237, 235, 0.48);
  font-variation-settings: "wght" 600;
  line-height: 20px;
  letter-spacing: 0.32px;
  &.accent {
    font-style: italic;
    background: #c8ff26;
    color: #000;
  }
`;

export const OpeningTitle = styled.h1`
  font-size: 64px;
  font-variation-settings: "wght" 700;
  margin: 0;
  line-height: 80px;

  span {
    color: #c8ff26;
  }
  @media (max-width: 1023px) {
    font-size: 48px;
    line-height: 56px;
  }
`;

export const Container = styled.div`
  margin: 0 auto;
  color: #faf8f7;
  padding: 0;
  max-width: 1184px;

  .text-accent {
    color: #c8ff26;
  }

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const AirdropWrapper = styled.div`
  background: #000;
  overflow: hidden;
  font-family: "PlusJakartaSans";
  padding: 0 24px;

  p,
  .body {
    font-weight: 400;
    font-variation-settings: "wght" 400;
  }
  p {
    color: #faf8f7;
  }

  .action,
  .headerM,
  .headerS,
  .headerL,
  h1 {
    font-weight: 400;
    font-variation-settings: "wght" 700;
  }

  .secondary {
    color: rgba(242, 237, 235, 0.48);
  }
  &.no-paddings {
    padding: 0;
  }
  @media (max-width: 768px) {
    .hide-mobile {
      display: none;
    }
  }
`;

export const OpeningDecor = styled.img`
  position: absolute;
  width: 800px;
  height: 800px;
  object-fit: contain;
  object-position: right center;
  top: 298px;
  right: -50px;
  transform: translateY(-50%);
  z-index: -1;
  @media (max-width: 1023px) {
    width: 390px;
    height: 390px;
    left: 50%;
    right: auto;
    top: 92px;
    transform: translate(-50%, 0%);
  }
`;

export const TextCentered = styled.div`
  text-align: center;
`;

export const HowToGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const StageUnit = styled.div`
  border-radius: 48px;
  background: #000;
  box-shadow: 0px 0px 40px 0px #999;
  padding: 48px var(--spacing-space-64, 64px) var(--spacing-space-96, 96px)
    var(--spacing-space-64, 64px);
  text-align: center;
  height: 472px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: default;
  p {
    color: rgba(242, 237, 235, 0.48);
  }
  .headerM {
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0.32px;
  }
  &.next p {
    color: #faf8f7;
  }
  &.current {
    box-shadow: 0px 0px 40px 0px #c8ff26;
    p {
      color: #faf8f7;
    }
    .action {
      color: #000;
    }
  }
  @media (max-width: 1023px) {
    padding: var(--spacing-space-32, 32px) var(--spacing-space-32, 32px)
      var(--spacing-space-96, 96px) var(--spacing-space-32, 32px);
    border-radius: var(--rounding-radius-xxl, 32px);
    height: 464px;

    .headerM {
      font-size: 24px;
      line-height: 32px;
      letter-spacing: 0.24px;
    }
  }
  ${TagsUnit} {
    color: #faf8f7;
    &.accent {
      color: #000;
    }
  }
`;

export const StageMedia = styled.img`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 448px;
  height: 264px;
  object-fit: contain;
  object-position: center bottom;
`;

export const AirdropHeader = styled.div`
  position: fixed;
  background: rgba(0, 0, 0, 0.16);
  backdrop-filter: blur(20px);
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  .selected-network {
    background: transparent;
    p {
      color: #fff;
    }
  }
`;

export const HeaderContainer = styled.div`
  margin: 0 auto;
  height: 96px;
  padding: 0 48px;
  max-width: 1440px;
  justify-content: space-between;
  display: flex;
  align-items: center;
  @media (max-width: 1024px) {
    padding: 0 22px;
    height: 56px;
  }
`;

export const HeaderLogo = styled.a`
  img {
    height: 32px;
    object-fit: contain;
    object-position: left center;
  }
  .mobile {
    display: none;
  }
  @media (max-width: 1024px) {
    .mobile {
      display: block;
      height: 26px;
    }
    .desktop {
      display: none;
    }
  }
`;

export const PointSystem = styled.div`
  border-radius: 56px;
  background: rgba(204, 187, 184, 0.16);
  backdrop-filter: blur(12px);
  padding: var(--spacing-space-48, 48px);
  @media (max-width: 1024px) {
    margin: 0 -24px;
    border-radius: var(--rounding-radius-xxl, 32px);
    padding: var(--spacing-space-24, 24px);
  }
  @media (max-width: 768px) {
    br {
      display: none;
    }
  }
`;

export const PointSystemGrid = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  gap: 32px;
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const PointCard = styled.div`
  border-radius: var(--rounding-radius-xl, 24px);
  background: rgba(204, 187, 184, 0.16);
  padding: var(--spacing-space-24, 24px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 220px;
  & > img {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }
  .headerM {
    font-size: 32px;
  }
  &.spark-info {
    height: 186px;
  }
  @media (max-width: 1024px) {
    height: 204px;
  }
`;

export const UntilBlock = styled.div`
  & > .headerL,
  & > .body {
    text-align: center;
  }
`;

export const UntilGrid = styled.div`
  display: grid;
  grid-template-columns: 236px 1fr 238px;
  gap: 8px 0;
  .lined {
    position: relative;
    padding-left: 12px;
    &::before {
      position: absolute;
      left: 0;
      top: 0;
      content: " ";
      width: 1px;
      height: 200px;
      background: #c8ff26;
    }
    &-last::before {
      height: 248px;
    }
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const UntilRow = styled.div`
  padding: var(--spacing-space-16, 16px) var(--spacing-space-32, 32px)
    var(--spacing-space-16, 16px) var(--spacing-space-16, 16px);
  border-radius: 40px;
  background: rgba(200, 255, 38, 0.16);
  display: flex;
  align-items: center;
  gap: 12px;
  margin-right: 8px;
  &.liq {
    grid-column: 1/3;
  }
  &.leverage {
    grid-column: 2/3;
    grid-row: 3/4;
  }
  .body {
    color: #c8ff26;
  }

  &.top {
    background: transparent;
  }
  &.mid {
    background: rgba(200, 255, 38, 0.16);
  }
  &.bot {
    background: #c8ff26;
    padding: 16px 32px 16px 16px;
    margin: -24px 0 0 0;
    .body {
      color: #000;
    }
  }
  @media (max-width: 1024px) {
    padding-bottom: 96px;
    margin: 0 0 -72px;
  }
`;

export const UntilSparks = styled.div`
  grid-column: 1/3;
  grid-row: 4/5;
  display: flex;
  padding: var(--spacing-space-8, 8px);
  justify-content: space-between;
  align-items: center;
  border-radius: var(--rounding-radius-xl, 24px);
  background: rgba(204, 187, 184, 0.16);
  margin-right: 8px;
  .row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .body {
    color: #c8ff26;
  }
  .arrow,
  .spark {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
`;

export const UtilThumb = styled.div`
  border-radius: 50%;
  background: #c8ff26;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
  .absolute {
    display: none;
  }
  @media (max-width: 1024px) {
    position: relative;
    isolation: isolate;
    &.airdrop img {
      width: 48px;
      height: 48px;
    }
    .absolute {
      position: absolute;
      display: block;
      left: 0;
      transform: translate(-84px, -50%);
      top: 50%;
      width: 90px;
      background: #c8ff26;
      z-index: -1;
      height: 1px;
      .body {
        position: absolute;
        top: -4px;
        transform: translateY(-100%);
        left: 0;
        white-space: nowrap;
        color: #fff;
      }
    }
  }
`;

export const UntilAirdrop = styled.div`
  border-radius: 40px;
  background: #c8ff26;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 168px;
  grid-column: 3/4;
  grid-row: 2/4;
  gap: 8px;
  .body {
    color: #000;
  }
  img {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
`;

export const UntilGridMobile = styled.div`
  display: none;
  margin-left: 68px;
  border-radius: 40px;
  background: rgba(200, 255, 38, 0.16);

  @media (max-width: 1024px) {
    display: block;
  }
`;

export const PreciousWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Precious = styled.div`
  border-radius: 48px;
  background: #252222;
  padding: var(--spacing-space-48, 48px);
  width: 100%;
  margin: 0 auto;
  max-width: 800px;
  .accent {
    color: #c8ff26;
  }
  @media (max-width: 1024px) {
    margin: 0 -24px;
    width: calc(100% + 48px);
    border-radius: var(--rounding-radius-xxl, 32px);
    padding: var(--spacing-space-24, 24px);
  }
`;

export const PreciousRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PreciousThumb = styled.div`
  border-radius: var(--rounding-radius-xl, 24px);
  background: rgba(204, 187, 184, 0.16);
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 24px;
    height: 24px;
  }
`;

export const PreciousBar = styled.div`
  border-radius: var(--rounding-radius-m, 16px);
  background: rgba(200, 255, 38, 0.16);
  padding: var(--spacing-space-12, 12px) var(--spacing-space-16, 16px);
  display: flex;
  gap: 8px;
  align-items: center;
  .body {
    color: #faf8f7;
  }
  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
`;

export const LeaderboardRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;

  & > div:first-child {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`;

export const LeaderboardBlock = styled.div`
  border-radius: 56px;
  background: linear-gradient(
    180deg,
    #252222 0%,
    #262322 4.7%,
    #272521 8.9%,
    #292720 12.8%,
    #2a2920 16.56%,
    #2c2b1f 20.37%,
    #2e2e1e 24.4%,
    #30321d 28.83%,
    #33361c 33.84%,
    #373a1a 39.6%,
    #3a4019 46.3%,
    #3f4617 54.1%,
    #444d14 63.2%,
    #4a5412 73.76%,
    #505d0f 85.97%,
    #57670c 100%
  );
  padding: var(--spacing-space-48, 48px);
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  ${LeaderboardRow} + ${LeaderboardRow} {
    margin-top: 16px;
  }

  .elevated {
    border-radius: var(--rounding-radius-xs, 8px);
    background: rgba(204, 187, 184, 0.16);
    box-shadow: 0px 2px 1px 0px rgba(51, 20, 0, 0.04),
      0px 4px 8px 0px rgba(51, 20, 0, 0.08);
    backdrop-filter: blur(12px);
  }

  @media (max-width: 1024px) {
    margin: 0 -24px;
    width: calc(100% + 48px);
    border-radius: var(--rounding-radius-xxl, 32px);
    padding: var(--spacing-space-24, 24px);
  }
`;

export const LeaderboardPlace = styled.div`
  border-radius: var(--rounding-radius-m, 16px);
  background: rgba(204, 187, 184, 0.16);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  min-width: 24px;
  height: 24px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #faf8f7;
  font-size: 12px;
  line-height: 10px;
  letter-spacing: 0.5px;
  &.first {
    background: #bfa34d;
  }
  &.second {
    background: #9da3a6;
  }
  &.third {
    background: #be9872;
  }
`;

export const LeaderboardLabel = styled.div`
  border-radius: var(--rounding-radius-m, 16px);
  background: #c8ff26;
  padding: 2px var(--spacing-space-8, 8px) 2px 5px;
  display: flex;
  align-items: center;
  gap: 2px;
  color: #000;
  height: 32px;
  img {
    width: 22px;
    height: 22px;
    object-fit: contain;
  }
`;

export const SparkinfoWrapper = styled.div`
  overflow: scroll;
  width: calc(100% + 48px);
  margin: 0 -24px;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }
  &::-moz-scrollbar {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }
  &::-webkit-scrollbar:horizontal {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    width: 0 !important;
    height: 0 !important;
    opacity: 0;
    background: rgba(255, 255, 255, 0);
    background-color: transparent;
    display: none !important;
  }
  &::-webkit-scrollbar-track-piece {
    width: 0 !important;
    height: 0 !important;
    opacity: 0;
    background: rgba(255, 255, 255, 0);
    background-color: transparent;
    display: none !important;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
    opacity: 0;
  }
  &::-webkit-scrollbar-track {
    opacity: 0;
    background: transparent;
    background-color: transparent;
    width: 0 !important;
    height: 0 !important;
    display: none !important;
  }
`;

export const SparkinfoGrid = styled.div`
  display: flex;
  gap: 32px;
  padding: 0 24px;
  & > * {
    flex-shrink: 0;
  }
`;

export const SparkinfoMedia = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  white-space: nowrap;
  & > * {
    flex-shrink: 0;
  }
  div:nth-child(3) {
    padding-right: 24px;
  }

  .thumb {
    border-radius: var(--rounding-radius-xl, 24px);
    background: rgba(204, 187, 184, 0.16);
    padding: var(--spacing-space-12, 12px);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    img {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }
`;

export const LeaderboardModal = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  z-index: 9999;
`;

export const ModalLayer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(20, 16, 15, 0.8);
`;

export const ModalClose = styled.button`
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  position: absolute;
  right: 32px;
  top: 32px;
  img {
    width: 24px;
    height: 24px;
  }
  &.mobile {
    display: none;
  }
  @media (max-width: 1024px) {
    display: none;
    &.mobile {
      display: block;
      top: 16px;
      left: 12px;
      right: auto;
      padding: 0;
      img {
        width: 28px;
        height: 28px;
      }
    }
  }
`;

export const LeaderboardBody = styled.div`
  border-radius: var(--rounding-radius-xxxl, 48px);
  background: #252222;
  box-shadow: 0px 8px 32px 0px rgba(51, 20, 0, 0.16);
  width: 520px;
  max-width: 100%;
  max-height: calc(100% - 128px);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  overflow: hidden;
  @media (max-width: 1024px) {
    max-height: 100vh;
    max-height: 100dvh;
    border-radius: 0;
    width: 100%;
    left: 0;
    top: 0;
    transform: translate(0, 0);
  }
`;

export const ModalHeading = styled.div`
  padding: 32px 32px 26px;
  @media (max-width: 1024px) {
    padding: 64px 24px 24px;
  }
`;

export const LeaderboardOverflow = styled.div`
  overflow: scroll;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  max-height: 632px;
  padding: 0 32px 32px;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }
  &::-moz-scrollbar {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }
  &::-webkit-scrollbar:horizontal {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    width: 0 !important;
    height: 0 !important;
    opacity: 0;
    background: rgba(255, 255, 255, 0);
    background-color: transparent;
    display: none !important;
  }
  &::-webkit-scrollbar-track-piece {
    width: 0 !important;
    height: 0 !important;
    opacity: 0;
    background: rgba(255, 255, 255, 0);
    background-color: transparent;
    display: none !important;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
    opacity: 0;
  }
  &::-webkit-scrollbar-track {
    opacity: 0;
    background: transparent;
    background-color: transparent;
    width: 0 !important;
    height: 0 !important;
    display: none !important;
  }

  ${LeaderboardRow} + ${LeaderboardRow} {
    margin-top: 24px;
  }

  @media (max-width: 1024px) {
    max-height: calc(100vh - 158px);
    max-height: calc(100dvh - 158px);
    padding: 0 24px 32px;
  }
`;
